import { z } from 'zod';

/** `POST /api/bots/:botId/unanswered/answer` body (spec D5/M5 task-4) — writes a Q&A pair
 * as a `type: 'text'` source through the same chain `routes/sources.ts` uses. */
export const unansweredAnswerSchema = z.object({
  // 2000 matches the public chat message cap (`public-chat.ts`/`playground.ts`) — a
  // visitor's own message becomes this "question" text verbatim once paired as unanswered,
  // so this cap must never be stricter than what the widget already accepted as input.
  question: z.string().min(1).max(2000),
  answer: z.string().min(1).max(8000),
});

export type UnansweredAnswerInput = z.infer<typeof unansweredAnswerSchema>;

/** `PATCH /api/bots/:botId/unanswered/:id` body (triage-state design 2026-08-21 §A). Only
 * `open`/`dismissed` are settable by hand — `answered` comes exclusively from `POST
 * .../unanswered/answer` (`markAnswered`), so it's deliberately excluded here rather than
 * reused from the full `UNANSWERED_STATUSES` catalog: a client PATCHing `status: 'answered'`
 * must 400, not silently flip a row into a state with no `answeredSourceId`. */
export const unansweredStatusPatchSchema = z.object({
  status: z.enum(['open', 'dismissed']),
});

export type UnansweredStatusPatchInput = z.infer<typeof unansweredStatusPatchSchema>;

/** `GET /api/bots/:botId/unanswered` query (triage-state design 2026-08-21 §A). Defaults to
 * `open` — the badge/segmented-control's default tab. */
export const unansweredListQuerySchema = z.object({
  status: z.enum(['open', 'dismissed', 'answered']).default('open'),
});

export type UnansweredListQuery = z.infer<typeof unansweredListQuerySchema>;
